enum SourceClient {
    OCTANE_EXTENSION = 'octane_extension',
    QUICK_APP = 'quick_app',
}

export default SourceClient
